
import * as actions from './actionTypes'

export function edit(fullname='', email='') {
  return {
    type: actions.EDIT,
    payload: { fullname: fullname, email: email }
  }
}

export function login(email='', password='', authfailed=false) {
  return {
    type: actions.LOGIN,
    //payload: { username: username, password: password }
    payload: { email: email, password: password, authfailed: authfailed }
  }
}

export function logout() {
  return {
    type: actions.LOGOUT
  }
}



// WEBPACK FOOTER //
// ./src/user/actions.js